import { baseApi } from './baseApi';
import type { User } from '../store/slices/authSlice';

interface LoginRequest {
  email: string;
  password: string;
}

interface LoginResponse {
  success: boolean;
  data: {
    token: string;
    user: User;
  };
}

interface RegisterRequest {
  name: string;
  email: string;
  password: string;
  role: 'admin' | 'customer' | 'member';
  customerId?: string;
}


export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
    }),
    register: builder.mutation<LoginResponse, RegisterRequest>({
      query: (userData) => ({
        url: '/auth/register',
        method: 'POST',
        body: userData,
      }),
    }),
    getCurrentUser: builder.query<{ success: true; data: User }, void>({
      query: () => '/auth/me',
    }),
    googleSignIn: builder.mutation<LoginResponse, { token: string }>({
      query: ({ token }) => ({
        url: '/auth/google/verify',
        method: 'POST',
        body: { token },
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useGetCurrentUserQuery,
  useGoogleSignInMutation,
} = authApi;